module.exports = __webpack_public_path__ + "img/EH.4cfd0a06.svg";